import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import CopyIcon from '../../assets/copy.png';


interface CopyConfirmationDialogProps {
    dialogVisible: boolean;
    dialogHeader: string;
    dialogBody: string;
    setDialogVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setCopyConfirmed: React.Dispatch<React.SetStateAction<boolean | null>>;
}

export const CopyConfirmationDialog = (props: CopyConfirmationDialogProps) => {
    return (
        <Dialog
                visible={props.dialogVisible}
                style={{ width: '25vw' }}
                onHide={() => {
                    props.setDialogVisible(false);props.setCopyConfirmed(null);
                }}
            >
                <div className="row" style={{textAlign:'center'}}>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    <img src={CopyIcon} alt="Copy" style={{ width: '54px', height: '40px', float: 'left', marginTop: '0.5rem' }} /></div>
                    <h4 style={{color:'#7D71E2'}}>{props.dialogHeader}</h4>
                        <p style={{ color: 'grey', marginTop: '-0.3rem' }}>{props.dialogBody}</p>
                        <div style={{ marginTop: '1rem' }}>
                            <Button 
                            // style={{border: '1px solid', borderRadius: '10px',height: '35px', marginRight: '10px'}}
                                label="No"
                                onClick={() => { props.setCopyConfirmed(false);props.setDialogVisible(false); }}
                                className="btn-secondary me-2"
                            />
                            <Button 
                            // style={{border: '1px solid', borderRadius: '10px',height: '35px'}}
                                label="Yes"
                                onClick={() => {
                                    props.setCopyConfirmed(true);props.setDialogVisible(false);
                                }}
                                className="btn-primary"
                                autoFocus
                            />
                        </div>
                    </div>
            </Dialog>
    );
};
